import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DataOptions from '../../core/DataOptions';
import HistoryViewer from '../../core/HistoryViewer';
import TripleViewer from '../../core/TripleViewer';
import LabelDetail from './LabelDetail';
import LabelSummaryDetail from './LabelSummaryDetail';
import { ENTITLEMENTS } from '../../application-core/constants';

class LabelData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    // schemeIRI gives us the taxonomy context within which we are looking at this label
    const { labelIRI, schemeIRI, onDeleteLabel, graph, viewLang, entitlements, linkedData, useWorkflow, projectUsers,
      propertyTemplates, associatedProject, project } = this.props;
    const { view } = this.state;

    const showOntologyProjects = entitlements.includes(ENTITLEMENTS.VIEW_ONTOLOGY_PROJECT) || entitlements.includes(ENTITLEMENTS.EDIT_ONTOLOGY_PROJECT);

    return (
      <div>
        <DataOptions
          handleNotAvailable={true}
          id={labelIRI}
          graph={graph}
          changeView={this.changeView}
          view={this.state.view} historyOption={true} />
        <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
          <LabelSummaryDetail
            handleNotAvailable={true}
            project={project}
            useWorkflow={useWorkflow}
            allowIRIchange={schemeIRI !== undefined}
            schemeIRI={schemeIRI}
            id={labelIRI}
            graph={graph}
            onDeleteLabel={onDeleteLabel} />
          {view === 0 && <LabelDetail
            handleNotAvailable={true}
            useWorkflow={useWorkflow}
            schemeIRI={schemeIRI}
            expectedTypes={["Label"]}
            linkedData={linkedData}
            entitlements={entitlements}
            projectUsers={projectUsers}
            associatedProject={associatedProject}
            propertyTemplates={propertyTemplates}
            showOntologyProjects={showOntologyProjects}
            id={labelIRI}
            viewLang={viewLang}
            graph={graph}
            onDeleteLabel={onDeleteLabel} />}
          {view === 1 && <TripleViewer handleNotAvailable={true} id={labelIRI} graph={graph} />}
          {view === 4 && <HistoryViewer handleNotAvailable={true} id={labelIRI} graph={graph} />}
        </div>
      </div>
    );
  }

}

LabelData.propTypes = {
  labelIRI: PropTypes.string.isRequired,
  entitlements: PropTypes.array.isRequired,
  linkedData: PropTypes.array,
  useWorkflow: PropTypes.bool,
  projectUsers: PropTypes.array,
  associatedProject: PropTypes.array,
  viewLang: PropTypes.string,
  project: PropTypes.string,
  graph: PropTypes.string.isRequired,
  propertyTemplates: PropTypes.array,
  schemeIRI: PropTypes.string,
  onDeleteLabel: PropTypes.func.isRequired
};

export default LabelData;